import Loader from '../../../components/Loader/Loader'

const ItemLoader = () => {
  return (
    <div className="visitor-analytics__item visitor-analytics__item-loader-container">
      <Loader className="loader" />
    </div>
  )
}

export default ItemLoader
